import { Component, OnInit } from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {AdminService} from '../../../shared/services/admin.service';
import {empty} from '../../../functions';
import {catchError} from 'rxjs/operators';
import { targetGroupOptions } from '../../../shared/services/job.service';

@Component({
    selector: 'app-modal-admin-account',
    templateUrl: './modal-admin-account.component.html',
    styleUrls: ['./modal-admin-account.component.scss'],
    standalone: false
})
export class ModalAdminAccountComponent implements OnInit {

  public data: any;
  targetGroupOptions = targetGroupOptions;

  entity = {
    id: '',
    emailAddress: '',
    firstName: '',
    lastName: '',
    infix: '',
    phoneNumber: '',
    allowEmailNotifications: false,
    isSubscribedToNewsletter: false,
    roles: <string[]> [],
    accountTargetGroups: <string[]> []
  };

  public roles = <any[]> [];
  public selectedRole = '';

  constructor(public activeModal: NgbActiveModal, public adminService: AdminService) {


  }

  ngOnInit(): void {

    if (!empty(this.data)) {
      this.entity = Object.assign({}, this.data);
    }

    this.adminService.apiGetAccountRoles().subscribe((roles:any) => {
      this.roles = roles;
    });

  }

  /**
   * Save data
   *
   * @constructor
   */
  Save() {

    if (!empty(this.entity.id)) {

      this.adminService.apiUpdateAccount(this.entity).pipe(catchError(this.adminService.handleError('apiUpdateAccount', false))).subscribe( (result) => {

        if (result !== false) {
          this.activeModal.close(true);
        }

      });


    } else {


      const { id, ...body } = this.entity;
      this.adminService.apiAddAccount(body).pipe(catchError(this.adminService.handleError('apiAddAccount', false))).subscribe( (result) => {

        if (result !== false) {
          this.activeModal.close(true);
        }

      });

    }

  }

}
